export enum RouterPathData {
  DETAILS,
  CONTENT,
}
